<div id="deferred-auth-banner" class="btn-primary  ms-auto me-auto"  *ngIf="displayed$ | async">
  <span *ngIf="(days$ | async) > 0">You have {{days$ | async}} days left of your free trial!</span>
  <span *ngIf="(days$ | async) <= 0">
    Your account is incomplete.&nbsp;&nbsp;Click <a [routerLink]="['/card-services/finalize-account']">here</a> to finalize.
  </span>
</div>
